import AttachmentEditor from '@components/AttachmentEditor'
import { Venue as VenueModel } from '@models/Venue'
import { updateVenueLogo } from '@services/VenueService'
import { useAppSelector } from '@store/hooks'
import { selectVenueById } from '@store/VenueReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { requiredRule } from '@utils/rules'
import { Flex, Form, Modal } from 'antd'
import { useState } from 'react'

type Props = SBModelComponent<VenueModel> & {
  trigger?: React.ReactNode
  onSuccess?: () => void
}

export const VenueAvatarModal = ({ id, model, trigger, onSuccess }: Props) => {
  const venue = model ? model : useAppSelector(selectVenueById(id!))
  const [form] = Form.useForm()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  if (!venue) {
    return <></>
  }

  const onFormModalSubmitted = (values: any) => {
    setIsLoading(true)
    const value = values.file[0].originFileObj
    updateVenueLogo(venue, value)
      .then(() => {
        form.resetFields()
        setIsOpen(false)
        onSuccess && onSuccess()
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <>
      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        onOk={() => form.submit()}
        confirmLoading={isLoading}
        okText="Submit"
      >
        <Form
          form={form}
          layout="vertical"
          name="attachment-editor"
          onFinish={onFormModalSubmitted}
        >
          <AttachmentEditor
            formItem={{ name: 'file', rules: [requiredRule()] }}
            dragger={{ fileTypes: ['picture'], multiple: false }}
            image={{ width: 512, height: 512, aspect: 1 }}
          />
        </Form>
      </Modal>
      <Flex onClick={() => setIsOpen(true)}>{trigger}</Flex>
    </>
  )
}

export type VenueAvatarModalType = { AvatarModal: typeof VenueAvatarModal }
